/**
 * @file edit-primary-categories.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/category/edit-primary-categories.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/category/edit-primary-categories
 * @description Edit primary category page for uProcure master categories module.
 *   Reuses the same form and logic as the AddPrimaryCategory page, but with
 *   pre-filled values and an API call to update instead of create. Accessed
 *   via the "Edit" action button on the primary category rows in the main
 *   categories list page.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Missing auditLogMessage in categoryJSON.editPrimaryCategory API payload â€” see uprocure-admin
 *   edit-primary-categories.tsx (generateLogMessageForCategory + warehouseName).
 */

import clsx from "clsx";
import React, { FC, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import UploadImage from "../.../../../../../../_admin/assets/media/svg_uTrade/add-img.svg";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import { categoryJSON } from "../../../../../api/apiJSON/master";
import { fileValidationImageOrSvg, fileValidationSVG } from "../../../../../Global/fileValidation";
import { success } from "../../../../../Global/toast";
import { masterToast } from "../../../../../utils/toast";
import Close from "../../../../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg";
import { Categories } from "../../../../../utils/constants";
// import { warehouse as warehouseStoreString } from '../../../../utils/storeString';
// import { getKey } from '../../../../Global/history';
import { useAuth } from "../../../auth";
import Method from "../../../../../utils/methods";
import { useWarehouse } from '../../../../context/WarehouseContext';
import { CustomToggleSwitch } from '../../../../custom/toggle-switch/CustomToggleSwitch';
const EditPrimaryCategory: FC = () => {
  const { currentUser } = useAuth();

  const { selectedWarehouse } = useWarehouse();
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [primaryCategory, setPrimaryCategory] = useState<{
    categoryName: string;
    categoryImage: string;
    categoryImageReader: any;
    activeCategoryImage: string;
    activeCategoryImageReader: any;
    svgCategoryImage: string;
    svgCategoryImageReader: any;
    isTobacco: boolean;
    isPharmacyCategory: boolean;
  }>({
    categoryName: state.title,
    categoryImage: state.image,
    categoryImageReader: state.image,
    activeCategoryImage: state.activeImage || "",
    activeCategoryImageReader: state.activeImage || "",
    svgCategoryImage: state.imageSvg || "",
    svgCategoryImageReader: state.imageSvg || "",
    isTobacco: state.isTobacco,
    isPharmacyCategory: state.isPharmacyCategory || false,
  });
  const [initialPrimaryCategory, setInitalPrimaryCategory] = useState<any>({
    categoryName: state.title,
    isTobacco: state.isTobacco,
    isPharmacyCategory: state.isPharmacyCategory || false,
  });
  const [validation, setValidation] = useState<{
    categoryName: boolean;
    categoryImage: boolean;
  }>({
    categoryName: false,
    categoryImage: false,
  });
  const [loading, setLoading] = useState(false);
  const handleCategoryName = (value: any, index: any) => {
    let temp = { ...primaryCategory };
    let validateTemp = { ...validation };
    temp.categoryName = value.trimStart();
    if (value.trimStart().length > 0) {
      validateTemp.categoryName = false;
    } else {
      validateTemp.categoryName = true;
    }
    setPrimaryCategory(temp);
    setValidation(validateTemp);
  };
  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: any,
  ) => {
    const selectedFiles = event.target.files;
    let temp = { ...primaryCategory };
    let validateTemp = { ...validation };
    if (!selectedFiles) return;
    else {
      if (fileValidationImageOrSvg(selectedFiles?.[0])) {
        validateTemp.categoryImage = false;
        temp.categoryImage = URL.createObjectURL(selectedFiles?.[0]);
        temp.categoryImageReader = selectedFiles?.[0];
        setPrimaryCategory(temp);
      }
    }
    setValidation(validateTemp);
  };
  const handleImageDiscard = (index: any) => {
    let temp = { ...primaryCategory };
    let validateTemp = { ...validation };
    validateTemp.categoryImage = true;
    temp.categoryImage = "";
    temp.categoryImageReader = {};
    setPrimaryCategory(temp);
    setValidation(validateTemp);
  };
  const handleActiveImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile && fileValidationImageOrSvg(selectedFile)) {
      setPrimaryCategory({
        ...primaryCategory,
        activeCategoryImage: URL.createObjectURL(selectedFile),
        activeCategoryImageReader: selectedFile,
      });
    }
  };
  const handleActiveImageDiscard = () => {
    setPrimaryCategory({
      ...primaryCategory,
      activeCategoryImage: "",
      activeCategoryImageReader: {},
    });
  };
  const handleSvgImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile && fileValidationSVG(selectedFile)) {
      setPrimaryCategory({
        ...primaryCategory,
        svgCategoryImage: URL.createObjectURL(selectedFile),
        svgCategoryImageReader: selectedFile,
      });
    }
  };
  const handleSvgImageDiscard = () => {
    setPrimaryCategory({
      ...primaryCategory,
      svgCategoryImage: "",
      svgCategoryImageReader: {},
    });
  };
  const handleSaveCategory = async () => {
    let temp = { ...primaryCategory };
    let validateTemp = { ...validation };
    if (!temp.categoryName && !temp.categoryImage) {
      validateTemp.categoryName = true;
      validateTemp.categoryImage = true;
    } else if (!temp.categoryName) {
      validateTemp.categoryName = true;
    } else if (!temp.categoryImage) {
      validateTemp.categoryImage = true;
    } else {
      setLoading(true);
      let apiService = new APICallService(
        master.editCategory,
        categoryJSON.editPrimaryCategory({ primaryCategory: primaryCategory }),
        { _id: state._id },
        "",
        "",
        "",
        Categories,
        selectedWarehouse?.value || null,
      );
      let response = await apiService.callAPI();
      if (response) {
        success(masterToast.editPrimaryCategory);
        navigate("/UProcure/master/categories");
        const data = Method.compareComplexObjects(
          initialPrimaryCategory,
          primaryCategory,
        );
        const updatedData = {
          ...data,
          categoryType: "Primary Category",
          categoryName: primaryCategory.categoryName,
        };
      }
    }
    setValidation(validateTemp);
    setLoading(false);
  };
  const handleTobacco = (value: any) => {
    let temp = { ...primaryCategory };
    temp.isTobacco = !temp.isTobacco;
    setPrimaryCategory(temp);
  };
  const handlePharmacyToggle = (value: boolean) => {
    let temp = { ...primaryCategory };
    temp.isPharmacyCategory = value;
    setPrimaryCategory(temp);
  };
  return (
    <div className="p-5">
      <Row>
        <Col lg={12} className="mb-6">
          <h1 className="fs-22 fw-bolder">Edit primary category</h1>
        </Col>
        <Col xs={12}>
          <Card className="border border-r10px bg-light position-relative mb-6">
            <Card.Body className="p-5">
              <Row>
                <Col lg={6} className="mb-6">
                  <Row className="align-items-center">
                    <Col lg={4}>
                      <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3">
                        Category name
                      </label>
                    </Col>
                    <Col lg={8}>
                      <input
                        type="text"
                        className={clsx(
                          "form-control form-control-solid bg-white h-60px border form-control-lg text-dark fs-16 fw-600",
                          validation.categoryName ? "border-danger" : "",
                        )}
                        name="name"
                        placeholder="Type hereâ€¦"
                        value={primaryCategory.categoryName}
                        onChange={(
                          e: React.ChangeEvent<HTMLInputElement>,
                        ): void => handleCategoryName(e.target.value, 0)}
                        disabled={loading}
                      />
                      <div className="fv-plugins-message-container">
                        <span className="text-danger fs-12 fw-bold">
                          {validation.categoryName
                            ? "Please enter category name"
                            : ""}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg={2} className="align-self-center">
                  <label className="fs-16 font-500">
                    Is the category related to tobacco?
                  </label>
                </Col>
                <Col lg={4} className="align-self-center d-lg-flex d-md-flex">
                  <div className="form-check form-check-custom form-check-solid me-4">
                    <input
                      className="form-check-input "
                      type="radio"
                      value="0"
                      id="flexRadioChecked"
                      checked={!primaryCategory.isTobacco}
                      onChange={(
                        e: React.ChangeEvent<HTMLInputElement>,
                      ): void => handleTobacco(e.target.value)}
                      disabled={loading}
                    />
                    <label className="form-check-label fs-16 fw-600 text-dark">
                      No
                    </label>
                  </div>
                  <div className="form-check form-check-custom form-check-solid">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="1"
                      id="flexRadioChecked"
                      checked={primaryCategory.isTobacco}
                      onChange={(
                        e: React.ChangeEvent<HTMLInputElement>,
                      ): void => handleTobacco(e.target.value)}
                      disabled={loading}
                    />
                    <label className="form-check-label fs-16 fw-600 text-dark">
                      Yes
                    </label>
                  </div>
                </Col>
                <Col lg={2} className="align-self-center">
                  <label className="fs-16 font-500">Is Pharmacy Category</label>
                </Col>
                <Col lg={4} className="align-self-center d-flex align-items-center gap-3">
                  <span className="fs-16 fw-600 text-dark">Off</span>
                  <CustomToggleSwitch
                    checked={primaryCategory.isPharmacyCategory}
                    onChange={handlePharmacyToggle}
                    disabled={loading}
                    size="md"
                  />
                  <span className="fs-16 fw-600 text-dark">On</span>
                </Col>
              </Row>
              <Row>
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3 mt-lg-3">
                    Upload category image
                  </label>
                </Col>
                <Col lg={10} className="d-flex">
                  <div className="d-flex flex-column">
                    <div className="upload-btn-wrapper">
                      <div className="symbol symbol-160px symbol-md-170px">
                        <img
                          className={clsx(
                            "border bg-white",
                            validation.categoryImage ? "border-danger" : "",
                          )}
                          src={
                            primaryCategory.categoryImage
                              ? primaryCategory.categoryImage
                              : UploadImage
                          }
                          alt=""
                        />
                      </div>
                      <input
                        className="w-100 h-100"
                        type="file"
                        name="myfile"
                        onChange={(
                          e: React.ChangeEvent<HTMLInputElement>,
                        ): void => handleImageChange(e, 0)}
                        disabled={loading}
                      />
                      <div className="fv-plugins-message-container">
                        <span className="text-danger fs-12 fw-bold">
                          {validation.categoryImage
                            ? "Please upload category image"
                            : ""}
                        </span>
                      </div>
                    </div>
                    <span className="text-gray text-italic">{`Image dimensions:-(700x700px)`}</span>
                  </div>
                  {primaryCategory.categoryImage && !loading ? (
                    <label
                      className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px responsive-closed"
                      data-kt-image-input-action="change"
                      title=""
                    >
                      <img
                        src={Close}
                        onClick={(): void => handleImageDiscard(0)}
                        className="responsive-closed-icon-closed"
                        alt=""
                        height={33}
                        width={33}
                      />
                    </label>
                  ) : (
                    <></>
                  )}
                  <div className="d-flex flex-column ms-4 justify-content-end">
                    <span className="fs-14 fw-500 text-italic">
                      Note: Please upload a high resolution PNG image
                    </span>
                    <span className="fs-14 fw-500 text-italic">
                      (No background) for the category image.
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-6">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3 mt-lg-3">
                    Upload category SVG image
                  </label>
                </Col>
                <Col lg={10} className="d-flex">
                  <div className="d-flex flex-column">
                    <div className="upload-btn-wrapper">
                      <div className="symbol symbol-160px symbol-md-170px">
                        <img
                          className="border bg-white"
                          src={
                            primaryCategory.svgCategoryImage
                              ? primaryCategory.svgCategoryImage
                              : UploadImage
                          }
                          alt=""
                        />
                      </div>
                      <input
                        className="w-100 h-100"
                        type="file"
                        name="imageSvgFile"
                        accept=".svg,image/svg+xml"
                        onChange={handleSvgImageChange}
                        disabled={loading}
                      />
                    </div>
                    <span className="text-gray text-italic">{`SVG format only`}</span>
                  </div>
                  {primaryCategory.svgCategoryImage && !loading ? (
                    <label
                      className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px responsive-closed"
                      title=""
                    >
                      <img
                        src={Close}
                        onClick={handleSvgImageDiscard}
                        className="responsive-closed-icon-closed"
                        alt=""
                        height={33}
                        width={33}
                      />
                    </label>
                  ) : (
                    <></>
                  )}
                  <div className="d-flex flex-column ms-4 justify-content-end">
                    <span className="fs-14 fw-500 text-italic">
                      Note: Please upload an SVG image
                    </span>
                    <span className="fs-14 fw-500 text-italic">
                      (No background) for the category icon.
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-6">
                <Col lg={2}>
                  <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3 mt-lg-3">
                    Upload active category image
                  </label>
                </Col>
                <Col lg={10} className="d-flex">
                  <div className="d-flex flex-column">
                    <div className="upload-btn-wrapper">
                      <div className="symbol symbol-160px symbol-md-170px">
                        <img
                          className="border bg-white"
                          src={
                            primaryCategory.activeCategoryImage
                              ? primaryCategory.activeCategoryImage
                              : UploadImage
                          }
                          alt=""
                        />
                      </div>
                      <input
                        className="w-100 h-100"
                        type="file"
                        name="activeImageFile"
                        onChange={handleActiveImageChange}
                        disabled={loading}
                      />
                    </div>
                    <span className="text-gray text-italic">{`Image dimensions:-(700x700px)`}</span>
                  </div>
                  {primaryCategory.activeCategoryImage && !loading ? (
                    <label
                      className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px responsive-closed"
                      title=""
                    >
                      <img
                        src={Close}
                        onClick={handleActiveImageDiscard}
                        className="responsive-closed-icon-closed"
                        alt=""
                        height={33}
                        width={33}
                      />
                    </label>
                  ) : (
                    <></>
                  )}
                  <div className="d-flex flex-column ms-4 justify-content-end">
                    <span className="fs-14 fw-500 text-italic">
                      Note: Please upload a high resolution PNG image
                    </span>
                    <span className="fs-14 fw-500 text-italic">
                      (No background) for the active category image.
                    </span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-end justify-content-md-start g-3">
        <Col xs="auto">
          <Button
            variant="danger"
            size="lg"
            className="uw-btn uw-btn-danger uw-btn-lg btn-active-danger"
            onClick={() => navigate("/UProcure/master/categories")}
          >
            {" "}
            Cancel
          </Button>
        </Col>
        <Col xs="auto">
          <Button className="uw-btn uw-btn-primary uw-btn-lg"
            variant="primary"
            size="lg"
            onClick={handleSaveCategory}
            disabled={loading}
          >
            {!loading && (
              <span className="indicator-label fs-16 fw-bold">
                Save category
              </span>
            )}
            {loading && (
              <span
                className="indicator-progress fs-16 fw-bold"
                style={{ display: "block" }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default EditPrimaryCategory;
